import { AuthDomainService } from '../../domain/services/AuthDomainService';
import { User } from '../../domain/entities/User';

/**
 * Application service for token management
 * Coordinates between domain and infrastructure layers
 */
export class TokenService {
  constructor(private authDomainService: AuthDomainService) {}

  /**
   * Store the token
   */
  setToken(token: string): void {
    //Store in local storage
    localStorage.setItem('token', token);
    //this.tokenRepository.setToken(token);
  }

  /**
   * Get the token
   */
  getToken(): string | undefined {
    //Get from local storage
    const token = localStorage.getItem('token');
    if (token) {
      return token;
    }
    //return this.tokenRepository.getToken();
  }

  /**
   * Remove the token
   */
  removeToken(): void {
    //Remove from local storage
    localStorage.removeItem('token');
    // Also clear login data when removing token
    localStorage.removeItem('loginData');
    //this.tokenRepository.removeToken();
  }

  /**
   * Verify if the token is valid and not expired
   * Delegates to domain service
   */
  verifyToken(token: string): boolean {
    return this.authDomainService.verifyToken(token);
  }

  /**
   * Extract user information from token
   * Delegates to domain service
   */
  extractUserFromToken(token: string): User | null {
    return this.authDomainService.extractUserFromToken(token);
  }
}
